// extracted by mini-css-extract-plugin
export default {"main":"Loading_main__UeSf8"};